import { render, staticRenderFns } from "./ReportSchoolsDiscipline.vue?vue&type=template&id=5929ab90&scoped=true"
import script from "./ReportSchoolsDiscipline.vue?vue&type=script&lang=js"
export * from "./ReportSchoolsDiscipline.vue?vue&type=script&lang=js"
import style0 from "./ReportSchoolsDiscipline.vue?vue&type=style&index=0&id=5929ab90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5929ab90",
  null
  
)

export default component.exports